import { ACTION_SDK_INITIATED } from '../Actions/Constants';

export function sdkInitiatedReducer(state = false, action = {}) {
   if (action.type === ACTION_SDK_INITIATED) {
      return action.payload.data;
   }
   return state;
}
